import { render, staticRenderFns } from "./EventShare.vue?vue&type=template&id=a79023c8"
import script from "./EventShare.vue?vue&type=script&lang=js"
export * from "./EventShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports